// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '9260dd11-cd13-4d4e-933a-7081ddace0fe',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: '359ccc40-0b02-4719-9923-e525d8bf9ae5',
      type: 'Container',
      name: 'wrapper',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '9260dd11-cd13-4d4e-933a-7081ddace0fe'
    },
    {
      id: 'ee31e7f6-bdd8-4cb0-a83e-b483ae3a2db6',
      type: 'Sprite',
      name: 'avatar',
      className: '',
      x: 0,
      y: 37,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.6,
        y: 1.6
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'avatar_placeholder',
      parent: '359ccc40-0b02-4719-9923-e525d8bf9ae5',
      stateByName: {
        currentPlayer: {
          scale: {
            x: 2,
            y: 2
          }
        }
      }
    },
    {
      id: 'f17334cf-9f27-4c9e-9bfe-6115e049b7f3',
      type: 'Sprite',
      name: 'levelLip',
      className: '',
      x: 0,
      y: 39,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Race_Points_Friends',
      parent: '359ccc40-0b02-4719-9923-e525d8bf9ae5',
      stateByName: {
        currentPlayer: {
          texture: 'Race_Points_Player'
        }
      }
    },
    {
      id: '80d6b946-ee5b-4ba2-b3f5-a71fa4a87c6a',
      type: 'Sprite',
      name: 'frame',
      className: '',
      x: 0,
      y: 52,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.8,
        y: 0.8
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Profile_Picture_Frame',
      parent: '359ccc40-0b02-4719-9923-e525d8bf9ae5',
      stateByName: {
        currentPlayer: {
          scale: {
            x: 1,
            y: 1
          }
        }
      }
    },
    {
      id: '7530c2ae-16a1-4e04-af93-cb9df6207171',
      type: 'Text',
      name: 'levelText',
      className: '',
      x: 0,
      y: 64,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 30,
        fontWeight: 'normal',
        fontFamily: 'Kanit{wf}',
        fill: 'white',
        stroke: '#6d1418',
        strokeThickness: 4,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#6d1418',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '359ccc40-0b02-4719-9923-e525d8bf9ae5'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '2.0.0',
  stateNames: [
    'currentPlayer'
  ],
  animations: [
    {
      id: '94a4ed3c-cd20-4975-9f86-6f9f518c88c1',
      name: 'Frame_Dance',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '3abebfba-9d20-4c60-aabe-2799d2294046',
          type: 'Tween',
          name: 'squeeze1',
          duration: 250,
          track: 0,
          target: {
            scale: {
              x: 1.05,
              y: 0.95
            }
          },
          startAt: 0,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'fb7805f9-7cb9-4ffb-84b2-b5de97d6e8fe',
          type: 'Tween',
          name: 'translation1',
          duration: 250,
          track: 1,
          target: {
            x: 0,
            y: -20
          },
          startAt: 0,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '848fdc20-0515-49b7-9005-12a32841337a',
          type: 'Tween',
          name: 'rotation1',
          duration: 250,
          track: 2,
          target: {
            angle: -5
          },
          startAt: 0,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '84ca7154-2fea-4626-be60-e32a823cac60',
          type: 'Tween',
          name: 'rotation2',
          duration: 250,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 250,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '02e9ab26-4c07-4ec1-9f07-398eee2fb325',
          type: 'Tween',
          name: 'translation2',
          duration: 250,
          track: 1,
          target: {
            y: 0
          },
          startAt: 250,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'afae1e87-f3ed-46ca-b513-0337f85673e2',
          type: 'Tween',
          name: 'squeeze2',
          duration: 250,
          track: 0,
          target: {
            scale: {
              x: 0.95,
              y: 1.05
            }
          },
          startAt: 250,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9612f8bf-c02d-4c0a-8be8-34a41238b3c9',
          type: 'Tween',
          name: 'rotation3',
          duration: 250,
          track: 2,
          target: {
            angle: 5
          },
          startAt: 500,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '058b2a5f-15cc-4eef-8936-88e195873a3a',
          type: 'Tween',
          name: 'translation1',
          duration: 250,
          track: 1,
          target: {
            x: 0,
            y: -20
          },
          startAt: 500,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '887eb6bc-31da-4f53-919d-97831fe82a99',
          type: 'Tween',
          name: 'squeeze3',
          duration: 250,
          track: 0,
          target: {
            scale: {
              x: 1.05,
              y: 0.95
            }
          },
          startAt: 500,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5c59683c-a027-48bc-bf1b-b16730e91a37',
          type: 'Tween',
          name: 'rotation2',
          duration: 250,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 750,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '13532f18-4cfb-4d95-b7b3-f03d8756dbe7',
          type: 'Tween',
          name: 'translation2',
          duration: 250,
          track: 1,
          target: {
            y: 0
          },
          startAt: 750,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c8fc4fab-136f-4566-8601-1807f9ba1666',
          type: 'Tween',
          name: 'squeeze4',
          duration: 250,
          track: 0,
          target: {
            scale: {
              x: 0.95,
              y: 1.05
            }
          },
          startAt: 750,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '10670cc1-fd2c-491a-a18b-53bde528e396',
          type: 'Tween',
          name: 'rotation1',
          duration: 250,
          track: 2,
          target: {
            angle: -5
          },
          startAt: 1000,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'bbcc2f2e-729c-4cfb-adb4-cb5db6c60627',
          type: 'Tween',
          name: 'translation1',
          duration: 250,
          track: 1,
          target: {
            y: -20
          },
          startAt: 1000,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5d808835-a506-4853-89ef-4159b1990248',
          type: 'Tween',
          name: 'squeeze5',
          duration: 250,
          track: 0,
          target: {
            scale: {
              x: 1.05,
              y: 0.95
            }
          },
          startAt: 1000,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '1c3d094f-de22-4a71-9c60-d7635c15a802',
          type: 'Tween',
          name: 'rotation2',
          duration: 250,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 1250,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9e970e91-fc71-4bc3-a36f-763364a41b0b',
          type: 'Tween',
          name: 'translation2',
          duration: 250,
          track: 1,
          target: {
            y: 0
          },
          startAt: 1250,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'c79e5280-d28c-4bb5-8ac8-9b3c91f6b6b7',
          type: 'Tween',
          name: 'squeeze6',
          duration: 250,
          track: 0,
          target: {
            scale: {
              x: 0.95,
              y: 1.05
            }
          },
          startAt: 1250,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b4b17d55-431f-4db3-82eb-6a2d941a1d7f',
          type: 'Tween',
          name: 'rotation3',
          duration: 250,
          track: 2,
          target: {
            angle: 5
          },
          startAt: 1500,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '9c07ac57-2347-4966-939e-8a9b519ff6a7',
          type: 'Tween',
          name: 'translation1',
          duration: 250,
          track: 1,
          target: {
            y: -20
          },
          startAt: 1500,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '64c4d868-dea5-431a-a676-b896f8b28f37',
          type: 'Tween',
          name: 'squeeze7',
          duration: 250,
          track: 0,
          target: {
            scale: {
              x: 1.05,
              y: 0.95
            }
          },
          startAt: 1500,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '92d57104-3363-4de4-86b2-d1d5ab7e7049',
          type: 'Tween',
          name: 'roation2',
          duration: 250,
          track: 2,
          target: {
            angle: 0
          },
          startAt: 1750,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '5066ebb7-16b1-4b2c-9904-1e54a77eb77c',
          type: 'Tween',
          name: 'translations2',
          duration: 250,
          track: 1,
          target: {
            y: 0
          },
          startAt: 1750,
          sourceName: 'wrapper',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '430a0263-7d9d-4609-9358-de52e3b8b6f7',
          type: 'Tween',
          name: 'squeeze8',
          duration: 250,
          track: 0,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1750,
          sourceName: 'root',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class RaceEventPlayerFrameLayout {
  static raw = raw;
  root!: Container;
  wrapper!: Container;
  avatar!: Sprite;
  levelLip!: Sprite;
  frame!: Sprite;
  levelText!: Text;
  StateName!: 'currentPlayer';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Frame_Dance {
  Layout: {
    root: object;
    wrapper: object;
  };

  BlockTypeByName: {
    squeeze1: object;
    translation1: object;
    rotation1: object;
    rotation2: object;
    translation2: object;
    squeeze2: object;
    rotation3: object;
    translation1: object;
    squeeze3: object;
    rotation2: object;
    translation2: object;
    squeeze4: object;
    rotation1: object;
    translation1: object;
    squeeze5: object;
    rotation2: object;
    translation2: object;
    squeeze6: object;
    rotation3: object;
    translation1: object;
    squeeze7: object;
    roation2: object;
    translations2: object;
    squeeze8: object;
  };

  flowData = raw.animations[0];
}
